import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The kind of professor we can all but hope to meet some day",
  "description": "",
  "published": "2010-01-11T00:00:00.000Z",
  "redirect_from": ["/blog/the-kind-of-professor-we-can-all-but-hope-to-meet-some-day/swizec/1146"],
  "categories": "Education, food for thought, Professor, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last night I watched a bloody amazing video of a university professor who was just `}<strong parentName="p">{`oozing awesome`}</strong>{`. Seriously, this guy is all kinds of cool and I would love to someday have a professor that structures his lectures and classes like this guy does.`}</p>
    <p>{`Now watch the video, I'm not here to blab, I'm here to make you watch this :)`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/70a8eb0d-a456-42eb-981e-1e2f7eb97af4/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=70a8eb0d-a456-42eb-981e-1e2f7eb97af4",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      